import { c as _c } from "react/compiler-runtime";
import SvgBlog from '@common/icon/SvgBlog';
import SvgYoutube from '@common/icon/SvgYoutube';
import { cn } from '@core/utils';
import Image from 'next/image';
import { getStaticCdnUrl } from '@/utils';
import { CHANNEL_LABEL } from '../../_utils/labels';
import type { Channel } from '../../_utils/types';
const CHANNEL_LOGO = {
  NAVER_BLOG: getStaticCdnUrl('partners/channel-naver-blog.png'),
  INSTAGRAM: getStaticCdnUrl('partners/channel-instagram.png')
};
const CHANNEL_ICON = {
  YOUTUBE: SvgYoutube,
  PERSONAL_BLOG: SvgBlog
};
interface ChannelMarkProps {
  channel: Exclude<Channel, 'ETC' | null>;
  className?: string;
}
export const ChannelMark = t0 => {
  const $ = _c(12);
  const {
    channel,
    className
  } = t0;
  if (channel === "NAVER_BLOG" || channel === "INSTAGRAM") {
    const t1 = CHANNEL_LOGO[channel];
    const t2 = CHANNEL_LABEL[channel];
    let t3;
    if ($[0] !== className) {
      t3 = cn("size-18 shrink-0 rounded-xxsmall", className);
      $[0] = className;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
      t4 = <Image src={t1} alt={t2} width={28} height={28} className={t3} />;
      $[2] = t1;
      $[3] = t2;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  const Icon = CHANNEL_ICON[channel];
  const t1 = CHANNEL_LABEL[channel];
  let t2;
  if ($[6] !== className) {
    t2 = cn("size-20 shrink-0 text-Gray-900", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== Icon || $[9] !== t1 || $[10] !== t2) {
    t3 = <Icon role="img" aria-label={t1} className={t2} />;
    $[8] = Icon;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};